import ServerError from 'errors/ServerError';
import { useGetCustomService } from './useGetCustomService';

export const useGetPortfolioVolatility = ({ isEnabled }) => {
    const result = useGetCustomService({
        service: 'customAdvisoryServices',
        api: 'getPortfolioVolatility',
        enabled: isEnabled,
        gcTime: 5 * 60 * 1000,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });

    return {
        data: result?.data?.data,
        statusCode: result?.data?.status,
        error: result.error ? new ServerError(result.error) : result.error,
    };
};
